"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.handleMixpanelInit = exports.MIXPANEL_TOKENS = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _utils = require("./utils");

var _entry = _interopRequireDefault(require("./entry"));

var _setProfileAndProperties = _interopRequireDefault(require("./setProfileAndProperties"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var MIXPANEL_TOKENS = {
  PRODUCTION: {
    INTERNAL: 'ba0c78a17a84aa4c798e60e59e6c9f2f',
    EXTERNAL: '03ffe4224bd5f3bdc6070db7fcbff897'
  },
  DEVELOPMENT: {
    INTERNAL: '8c7d4713e667b637c642016ba148f634',
    EXTERNAL: '8c7d4713e667b637c642016ba148f634'
  }
};
exports.MIXPANEL_TOKENS = MIXPANEL_TOKENS;

/**
 * Initializes mixpanel using user information extracted
 * from a given portal JWT and a user's account manager.
 * @param {string} [accessJwt=''] An encoded access JWT from portal
 * @param {string} [currentProduct=''] The active product
 * @param {string} [accountManager=''] DEPRECATED The current user's account manager's email
 * @param {boolean} [production=false] Whether to use production mixpanel
 * @param {number} [recordSessionsPercent=0] The percentage of sessions to record (integer 0–100; invalid values default to 0)
 * @param {Function} [setProps] A callback function to set mixpanel
 */
var handleMixpanelInit = function handleMixpanelInit() {
  var _mntl$props$Departmen, _mntl$props, _mntl$mail;

  var accessJwt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var currentProduct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var accountManager = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var production = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var recordSessionsPercent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var setProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _setProfileAndProperties.default;

  var _ref = accessJwt ? (0, _jwtDecode.default)(accessJwt) : {
    mntl: {}
  },
      mntl = _ref.mntl;

  var userData = {
    email: mntl.mail,
    user_id: mntl.usr_id,
    user_group: mntl.grp,
    user_group_id: mntl.grp_id,
    organization: mntl.org,
    organization_id: mntl.org_id,
    current_product: currentProduct,
    department: (_mntl$props$Departmen = (_mntl$props = mntl.props) === null || _mntl$props === void 0 ? void 0 : _mntl$props.Department) !== null && _mntl$props$Departmen !== void 0 ? _mntl$props$Departmen : mntl.dept,
    anon: accessJwt === '' ? true : mntl.anon
  }; // Check the user's email domain as well as their org to cover
  // masquerading and freelancers.

  var mixpanelToken = MIXPANEL_TOKENS[production ? 'PRODUCTION' : 'DEVELOPMENT'][(_mntl$mail = mntl.mail) !== null && _mntl$mail !== void 0 && _mntl$mail.endsWith('@mintel.com') || mntl.org === 'Mintel' ? 'INTERNAL' : 'EXTERNAL'];

  var normalizeRecordSessionsPercent = function normalizeRecordSessionsPercent(value) {
    return value >= 0 && value <= 100 ? value : 0;
  };

  var optOutSessionReplay = accessJwt === '' || mntl.opt_out_session_replay === undefined ? false : mntl.opt_out_session_replay;
  var effectiveRecordSessionsPercent = optOutSessionReplay ? 0 : normalizeRecordSessionsPercent(recordSessionsPercent);

  _mixpanelBrowser.default.init(mixpanelToken, {
    api_host: 'https://mix.mintel.com',
    loaded: function loaded() {
      setProps(userData);
      if (!userData.anon) (0, _utils.sessionStart)();
    },
    disable_persistence: true,
    ignore_dnt: accessJwt === '' || mntl.ignore_dnt === undefined ? false : mntl.ignore_dnt,
    record_sessions_percent: effectiveRecordSessionsPercent
  }); // Add the library to the window for libraries and services that expect it there


  window.mintel_tracking = _entry.default;
};
/**
 * Initializes mixpanel using user information extracted
 * from a given portal JWT.
 * @param {string} [accessJwt=''] An encoded access JWT from portal
 * @param {string} [portalJwt=''] An encoded JWT from portal
 * @param {string} [currentProduct=''] The active product
 * @param {boolean} [production=false] Whether to use production mixpanel
 * @param {number} [recordSessionsPercent=0] The percentage of sessions to record (integer 0–100; invalid values default to 0)
 * @param {Function} [setProps] A callback function to set mixpanel
 * properties, exposed for testing
 */


exports.handleMixpanelInit = handleMixpanelInit;

var _default = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var accessJwt,
      portalJwt,
      currentProduct,
      production,
      recordSessionsPercent,
      setProps,
      _args = arguments;
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          accessJwt = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
          portalJwt = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
          currentProduct = _args.length > 2 && _args[2] !== undefined ? _args[2] : undefined;
          production = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
          recordSessionsPercent = _args.length > 4 && _args[4] !== undefined ? _args[4] : 0;
          setProps = _args.length > 5 && _args[5] !== undefined ? _args[5] : _setProfileAndProperties.default;
          handleMixpanelInit(accessJwt, currentProduct, '', production, recordSessionsPercent, setProps);

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));

exports.default = _default;